import { Component } from 'react';
import { RelatedLink } from '../../../types/site-urls';
import styles from './related-links.component.module.scss';
import { groupBy } from '../../../utils/lodash-min';
import { StringUtils } from '../../../utils/string-utils';


interface RelatedLinksComponentProps {
    relatedLinks: RelatedLink[];
}
/**
 * Each anchor carries `data-block` = the xconvert-web-ssr link-policy block that emitted it (siblings / hubs / reverse / hub-list /
 * hub-media-list; `related` for the legacy mesh) so the link-hierarchy HTML assertion (link-hierarchy-20261026 METHOD §5.2) can count
 * blocks without depending on CSS-module class names. Grouping and headings are unchanged. The href is the site-absolute
 * `converterType.link` ("/compress-gif"); `url` is the bare slug and used to be emitted as a relative href ("compress-gif"),
 * which only resolved because every feature page sits at the root.
 */
export class RelatedLinksComponent extends Component<RelatedLinksComponentProps> {
    relatedLinks: { title: string; links: RelatedLink[]; }[];

    constructor(props: RelatedLinksComponentProps) {
        super(props);
        const groups = groupBy(this.props.relatedLinks, (v) => v.converterType.type);
        this.relatedLinks = Object.keys(groups).map(k => {
            return {
                title: StringUtils.capitalizeFirstLetter(k),
                links: groups[k]
            }
        }).sort().reverse()

    }

    componentDidCatch(err) {
        console.log(err);
    }

    render() {
        return <div className="card section text-left" >
            <div className='row'>
                {
                    this.relatedLinks.map((v) => {
                        return <div className={(v.links.length > 16 ? 'col-12' : 'col-12 col-md-6') + ' mb-3'} key={v.title}>
                            <h5 className={styles['section-title']}>Related {v.title} tools</h5>
                            <div className={v.links.length > 16 ? styles['pills-grid'] : styles['pills']}>
                                {
                                    v.links.filter(link => link.converterType)
                                        .map((link, index) => <a key={index} href={link.converterType.link || `/${link.url}`} title={link.converterType.title} className={styles['pill']}
                                            data-block={(link.converterType as any).block || 'related'}>
                                            {link.converterType.title}</a>)
                                }
                            </div>
                        </div>
                    })
                }
            </div>
        </div >
    }
}